import { RootState } from '../store';

export const selectResponses = (state: RootState) => state.responses.responses;
export const selectResponseModal = (state: RootState) => state.responses.responseModal;